import {PlayerBetPredictionDomainModel} from "./player-bet-prediction.domain-model";
import {PredictionViewModel} from "../prediction/prediction-view-model";
import {override} from "mobx";
import {BetsLineViewModel} from "../../../bets-lines/models/bets-line.view-model";
import {ODDS_TYPES} from "../../../../core/components/odds/components/odds-consts";
import {EXTRA_LINKS_CONTEXTS, GAME_STATUSES} from "../../../../core/app/consts";
import {AthleteViewModel} from "../../../common/athlete/athlete-view-model";

export class PlayerBetPredictionViewModel extends PredictionViewModel {
  domainModel: PlayerBetPredictionDomainModel;
  athleteId: Number;
  recordsText: String;
  parameter: String;

  constructor(index: Number, domainModel: PlayerBetPredictionDomainModel, selectedVoteNum: Number = -1, oddsType: ODDS_TYPES, gameStatus: GAME_STATUSES, gameId: Number, context: EXTRA_LINKS_CONTEXTS, liveMode: Boolean = false) {
    super(index, domainModel, selectedVoteNum, oddsType, gameStatus, gameId, context, liveMode);

    this.athleteId = domainModel.athleteId;
    this.athlete = domainModel.athlete ? new AthleteViewModel(domainModel.athlete) : null;
    this.recordsText = domainModel.recordsText;
    this.parameter = domainModel.parameter;
  }

  @override get odds(): BetsLineViewModel {
    if (!this.hasOdds) {
      return null;
    }

    return new BetsLineViewModel(this.domainModel.odds, this.oddsType);
  }
}